import React, { Suspense, useEffect, lazy } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Analytics from "./components/Analytics";
import CookieBanner from "./components/CookieBanner";
import useReveal from "./utils/useReveal";

const Location = lazy(() => import("./pages/Location"));
const StoreDetail = lazy(() => import("./pages/StoreDetail"));
const NotFound = lazy(() => import("./pages/NotFound"));

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function RouteFallback() {
  return <div style={{ minHeight: "60vh" }} aria-hidden="true" />;
}

function App() {
  useReveal();

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Analytics />
        <div className="app">
          <Header />
          <main>
            <Suspense fallback={<RouteFallback />}>
              <Routes>
                <Route path="/" element={<Location />} />
                <Route path="/store/:slug" element={<StoreDetail />} />
                <Route
                  path="/store/:slug/:page"
                  element={<StoreDetail />}
                />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
          <CookieBanner />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
